import { useState, useEffect } from "react";

// Hook pentru gestionarea actualizărilor aplicației
export const useAppUpdate = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [registration, setRegistration] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      let messageHandler;
      let controllerChangeHandler;

      // Ascultă mesajele de la service worker
      messageHandler = (event) => {
        if (event.data && event.data.type === "NEW_VERSION_AVAILABLE") {
          setUpdateAvailable(true);
          setRegistration(event.data.registration);
        }
      };

      // Ascultă pentru actualizări de service worker
      controllerChangeHandler = () => {
        setIsUpdating(true);
        // Reîncarcă pagina după ce service worker-ul nou a preluat controlul
        setTimeout(() => {
          window.location.reload();
        }, 100);
      };

      navigator.serviceWorker.addEventListener("message", messageHandler);
      navigator.serviceWorker.addEventListener("controllerchange", controllerChangeHandler);

      // Verifică dacă există deja un service worker înregistrat
      navigator.serviceWorker.ready.then((registration) => {
        setRegistration(registration);

        // Verifică dacă există update waiting
        if (registration.waiting) {
          setUpdateAvailable(true);
        }

        // Ascultă pentru evenimentul de update found
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;

          if (newWorker) {
            newWorker.addEventListener("statechange", () => {
              if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
                // Noua versiune este instalată și ready
                setUpdateAvailable(true);
                setRegistration(registration);
              }
            });
          }
        });
      }).catch((error) => {
        console.warn("Service Worker registration failed:", error);
      });

      // Cleanup function
      return () => {
        if (messageHandler) {
          navigator.serviceWorker.removeEventListener("message", messageHandler);
        }
        if (controllerChangeHandler) {
          navigator.serviceWorker.removeEventListener("controllerchange", controllerChangeHandler);
        }
      };
    }
  }, []);

  const updateApp = () => {
    if (registration && registration.waiting) {
      setIsUpdating(true);
      // Trimite mesaj către service worker să ia controlul
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    } else {
      // Fallback: reîncarcă pagina
      setIsUpdating(true);
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  };

  const dismissUpdate = () => {
    setUpdateAvailable(false);
  };

  return {
    updateAvailable,
    updateApp,
    dismissUpdate,
    isUpdating,
  };
};